/** A person an admin removed from the room. Agents are never removed this way. */
export function isArchivedMember(actor: { kind: string; archived?: boolean | null }): boolean {
  return actor.kind === "human" && actor.archived === true;
}
